import React, { useEffect, useState } from "react";
import "./membersmng.css";
import { Link } from "react-router-dom";
import api from "../../services/axios";

const Membersmng = () => {
  const [members, setMembers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalMembers, setTotalMembers] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchMembers = async (page = 1) => {
    setLoading(true);
    setError("");

    try {
      const response = await api.get(`/auth/get_members`, {
        params: { page, limit: itemsPerPage },
      });

      setMembers(response.data?.members || []);
      setTotalPages(response.data?.pagination?.totalPages || 1);
      setTotalMembers(response.data?.pagination?.total || 0);
    } catch (fetchError) {
      setError("Error fetching member data.");
      console.error("Error fetching member data:", fetchError);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers(currentPage);
  }, [currentPage]);

  const approveMember = async (id) => {
    try {
      const response = await api.post(`/auth/approve_member`, { id });
      console.log(response.data);

      setMembers((prev) =>
        prev.map((member) =>
          member.id === id ? { ...member, approved: true } : member
        )
      );
    } catch (approveError) {
      console.error("Error approving member:", approveError);
    }
  };

  const deleteMember = async (id) => {
    try {
      await api.delete(`/auth/delete_member/${id}`);
      console.log(`Member with id ${id} deleted`);

      const nextPage = members.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;

      if (nextPage !== currentPage) {
        setCurrentPage(nextPage);
      } else {
        fetchMembers(currentPage);
      }
    } catch (deleteError) {
      console.error("Error deleting member:", deleteError);
    }
  };

  const startIndex = totalMembers === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, totalMembers);

  return (
    <div id="manage">
      <div className="manage__content">
        <ul className="manage__list">
          <li className="manageListItem" onClick={() => window.location.href = '/dashboard/addmember'}>
            Add New Member
          </li>
          <li className="manageListItem">Edit Member Information</li>
          <li className="manageListItem">Search Member</li>
        </ul>
        <hr />
        <div className="membersTable">
          <h4 className="membersTableHeader">List of Registered Members</h4>
          <p className="membersPaginationInfo">
            {`Showing ${startIndex}-${endIndex} of ${totalMembers}`}
          </p>
        </div>
        {error && <p className="membersError">{error}</p>}
        <div className="tableDiv">
          <table className="memberTable">
            <thead className="tableHeader">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Date of Birth</th>
                <th>Phone Number</th>
                <th>Communication</th>
                <th>Date Joined</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="tableBody">
              {!loading && members.map((member) => (
                <tr key={member.id}>
                  <td>{`${member.FirstName} ${member.LastName}`}</td>
                  <td>{member.Email}</td>
                  <td>{member.DateOfBirth}</td>
                  <td>{`${member.PhoneNumber}`}</td>
                  <td>{member.PreferredCommunication}</td>
                  <td>{member.DateJoined}</td>
                  <td>
                    <Link to={`/dashboard/edit/` + member.id}>
                      <button className="editMemberBtn">Edit</button>
                    </Link>
                    <button
                      className="deleteMemberBtn"
                      onClick={() => deleteMember(member.id)}
                    >
                      Delete
                    </button>
                    <button
                      className="approveMemberBtn"
                      onClick={() => approveMember(member.id)}
                    >
                      Approve
                    </button>
                  </td>
                </tr>
              ))}
              {!loading && members.length === 0 && (
                <tr>
                  <td colSpan="7" className="membersEmptyRow">
                    No members found.
                  </td>
                </tr>
              )}
              {loading && (
                <tr>
                  <td colSpan="7" className="membersEmptyRow">
                    Loading members...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="paginationControls">
          <button
            className="manageListItem paginationBtn"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1 || loading}
          >
            Previous
          </button>
          <span className="paginationLabel">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            className="manageListItem paginationBtn"
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages || loading}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Membersmng;
